// LineChart.js
import React from "react";
import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";
import { CHART_HEIGHT, VERTICAL_AXIS_WIDTH } from "./LineChart";

export const VerticalAxis = ({ yAxisOnlyOptions }) => {
  return (
    <div style={{ height: `${CHART_HEIGHT}px`, width: `${VERTICAL_AXIS_WIDTH}px` }}>
      <HighchartsReact highcharts={Highcharts} options={yAxisOnlyOptions} />
    </div>
  );
};
